module.exports = __webpack_public_path__ + "static/media/beverley.da758f89.jpg";